export const backend_url = process.env.REACT_APP_BACKEND_URL || "";
export const backend_api = process.env.REACT_APP_BACKEND_API || "";
export const google_client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
export const linkedIn_client_id =
  process.env.REACT_APP_LINKEDIN_CLIENT_ID || "";
export const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID || "";
export const stripe_token = process.env.REACT_APP_STRIP_TOKEN || "";
